@for (training of trainingDetails; track training) {
  <div>
    <br/>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>Training site name</label>
          <div
            type="text"
            class="form-control readonly"
            [innerHTML]="training?.trainingSiteName"
          ></div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Training site address</label>
          <div
            type="text"
            class="form-control readonly"
            [innerHTML]="training?.trainingSiteAddress"
          ></div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>Start date</label>
          <div
            type="text"
            class="form-control readonly"
            [innerHTML]="(training?.trainingStartDate | utcDate) || '-'"
          ></div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>End date</label>
          <div
            type="text"
            class="form-control readonly"
            [innerHTML]="(training?.trainingEndDate | utcDate) || '-'"
          ></div>
        </div>
      </div>
    </div>
  </div>
}
